<template>
  <div class="page page-Contacts" :class="{ loaded: isLoaded}">

    <div class="content content--no-padding" :class="{'clear-padding': mapFullScreen}">
      <div class="map-outer" :class="{fullscreen: mapFullScreen}">
        <div class="map-block">
          <div class="title glitch" v-if="!isMobile"><div class="glitch-action" v-html="_('addressCity')" :data-text="_('addressCity')"></div></div>

          <div class="text" v-if="!isMobile" v-html="_('text')"></div>

          <div class="contacts">
            <div class="contacts__row contacts__address"><span v-if="isMobile">{{ _('addressCity') }}, </span><span v-html="_('address')"></span></div>
            <template v-for="row in _('addressRows')">
              <div class="contacts__row">{{ row.name }}: {{ row.value }}</div>
            </template>
          </div>

          <div class="btns glitch">
            <a :href="_('urlMap')" class="btn btn--square btn--big btn--gray"><span><span class="glitch-action" v-html="_('btnShowMap')" :data-text="_('btnShowMap')"></span></span></a>
          </div>
        </div>
        <div class="map">
          <GmapMap ref="mapRef" v-if="mapParams.center != false"
                   :center="mapParams.center"
                   :zoom="mapParams.zoom"
                   style="width: 100%; height: 100%"
                   :options="mapOptions"
          >
            <GmapMarker
              :position="mapParams.center"
              :icon="{ url: require('../assets/images/dot.svg')}"
            />
          </GmapMap>

          <div class="map-zoom">
            <div class="map-zoom__plus" @click="mapZoom(1)"></div>
            <div class="map-zoom__minus" @click="mapZoom(-1)"></div>
          </div>
          <div class="map-fullscreen" @click="setMapFullScreen()"></div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import {loader} from '../mixins/loader';
  import {isMobile} from '../mixins/isMobile';
  import {functions} from '../mixins/functions';

  export default {
    name: 'Contacts',
    mixins: [loader, isMobile, functions],

    data() {
      return {
        pageData: {page: 'Contacts'},
        backgroundImages: [],
        mapFullScreen: false,
        mapParams: {
            center: false,
            zoom: 13,
        },
        mapOptions: {
            zoomControl: false,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            disableDefaultUi: false,
            styles: [{"featureType":"all","elementType":"geometry","stylers":[{"color":"#312f30"}]},{"featureType":"all","elementType":"geometry.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"}]},{"featureType":"all","elementType":"labels.text.fill","stylers":[{"visibility":"on"},{"color":"#ffffff"}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"weight":2},{"visibility":"off"},{"color":"#76b840"}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"gamma":"1.27"}]},{"featureType":"administrative","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"administrative.country","elementType":"geometry.fill","stylers":[{"gamma":"1.14"}]},{"featureType":"administrative.province","elementType":"geometry","stylers":[{"gamma":"1.34"}]},{"featureType":"administrative.locality","elementType":"geometry","stylers":[{"saturation":"0"},{"gamma":"2.15"},{"weight":"1.81"}]},{"featureType":"landscape","elementType":"geometry.fill","stylers":[{"gamma":"0.74"}]},{"featureType":"landscape","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"landscape.man_made","elementType":"geometry","stylers":[{"visibility":"simplified"}]},{"featureType":"landscape.man_made","elementType":"geometry.fill","stylers":[{"visibility":"off"}]},{"featureType":"landscape.man_made","elementType":"geometry.stroke","stylers":[{"visibility":"simplified"}]},{"featureType":"landscape.man_made","elementType":"labels.text.stroke","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"visibility":"on"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"lightness":20},{"saturation":-20},{"visibility":"off"}]},{"featureType":"road","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road","elementType":"geometry.stroke","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"labels","stylers":[{"color":"#312f30"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#312f30"},{"visibility":"on"}]},{"featureType":"road","elementType":"labels.text.stroke","stylers":[{"visibility":"off"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#e40139"}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"color":"#0c51de"}]},{"featureType":"road.arterial","elementType":"labels.text.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"transit.line","elementType":"geometry.fill","stylers":[{"color":"#e40139"}]},{"featureType":"water","elementType":"all","stylers":[{"lightness":-20},{"visibility":"off"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#b429a5"},{"lightness":"-29"},{"gamma":"1.84"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#ff0000"}]}]
        }
      }
    },

    deactivated() {
      this.isLoaded = false;
    },

    //activated() {
    mounted() {
      var _t = this;

      if (_t.$store.state.pagesLoaded.App && _t.$store.state.pagesLoaded.Contacts) {
        _t.onActivated();
      } else {
        //_t.$store.commit('loaderON');

        _t.$store.subscribe((mutation, state) => {
          if (mutation.type === 'pageLoaded' && mutation.payload.page == 'Contacts') {
            _t.onActivated();
          }
        });
      }
    },

    created(){
      this.$store.dispatch('loadData', {
        page: 'Contacts'
      });
    },

    methods: {
      onActivated() {
        var _t = this;

        _t.mapParams = _t._('mapParams');

        _t.pageLoaded();
      },
      mapZoom(delta) {
          this.$refs.mapRef.$mapPromise.then((map) => {
              map.setZoom(map.getZoom() + delta);
          })
      },
      setMapFullScreen() {
          let _t = this;

          _t.mapFullScreen = !_t.mapFullScreen;
          _t.$store.commit('toggleMapFullScreen');
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Contacts.vue